import {
	Campaign,
	CreateReferralPayload,
	GenerateReferralCodePayload,
	MyReferralsResponse,
	CreditsBalance,
	ReferralCode,
	UpdateReferralStepsPayload,
} from '../@types/Referrals.type';
import { del, get, patch, post } from '../shared/utils/FetchV2.util';

// Cutover: referrals migró del heru-core-referrals-service (NestJS) al módulo
// referrals del sales-transaction-engine; mismos subpaths bajo la base del engine.
const SERVICE = 'salesTransactionEngine' as const;


export const getAllCampaigns = async (): Promise<Campaign[]> => {
	return get<Campaign[]>({
		service: SERVICE,
		endpoint: '/campaigns',
	});
};


export const generateReferralCode = async (
	payload: GenerateReferralCodePayload,
): Promise<ReferralCode> => {
	const response = await post<{ referralCode: ReferralCode }>({
		service: SERVICE,
		endpoint: '/referral-codes/generate',
		body: payload,
	});
	return response.referralCode;
};

export const getReferralCodeByUser = async (
	userId: number,
): Promise<ReferralCode> => {
	return get<ReferralCode>({
		service: SERVICE,
		endpoint: `/referral-codes/${userId}`,
	});
};

export const getMyReferrals = async (
	userId: number,
	campaignId?: number,
): Promise<MyReferralsResponse> => {
	const query = campaignId ? `?campaignId=${campaignId}` : '';
	return get<MyReferralsResponse>({
		service: SERVICE,
		endpoint: `/referral-codes/my-referrals/${userId}${query}`,
	});
};


export const createReferral = async (
	payload: CreateReferralPayload,
) => {
	return post({
		service: SERVICE,
		endpoint: '/referrals',
		body: payload,
	});
};

export type ValidateReferralCodeResponse = {
	id: number;
	code: string;
	status: string;
	isValid: boolean;
	userId: number;
	// Nombre del dueño del código (referidor); el engine lo resuelve best-effort
	// vía users-service, así que puede venir null aunque el código sea válido.
	name?: string | null;
	lastName?: string | null;
};

export const validateReferralCode = async (
	code: string,
	userId?: number,
): Promise<ValidateReferralCodeResponse> => {
	const query = userId ? `?userId=${userId}` : '';
	return get<ValidateReferralCodeResponse>({
		service: SERVICE,
		endpoint: `/referral-codes/validate/${code}${query}`,
	});
};

export const updateReferralSteps = async (
	code: string,
	refereeId: number,
	payload: UpdateReferralStepsPayload,
	campaignId?: number,
) => {
	const params = new URLSearchParams({ refereeId: String(refereeId) });
	if (campaignId) params.append('campaignId', String(campaignId));
	const query = `?${params.toString()}`;
	return patch({
		service: SERVICE,
		endpoint: `/referrals/code/${code}/steps${query}`,
		body: payload,
	});
};

export const getCreditsBalance = async (): Promise<CreditsBalance> => {
	return get<CreditsBalance>({
		service: SERVICE,
		endpoint: '/credits/balance',
	});
};

// Applies heru-créditos to the cart: the engine computes min(balance, 50% of
// the total) and adjusts the cart server-side. Errors: 403 (not the cart's
// owner), 422 (nothing applicable).
export const applyCartCredits = async (cartId: number) => {
	return post({
		service: SERVICE,
		endpoint: `/credits/cart/${cartId}`,
		body: {},
	});
};

export const removeCartCredits = async (cartId: number) => {
	return del({
		service: SERVICE,
		endpoint: `/credits/cart/${cartId}`,
	});
};
